import {
  LIST_WIDTH,
  ARCHIVED_COLUMN,
} from '../../../../utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Department ID',
    field: 'departmentId',
    width: LIST_WIDTH.xxl,
  },
  {
    headerName: 'Name',
    field: 'name',
    width: LIST_WIDTH.xxl,
  },
  {
    headerName: 'Notes',
    field: 'notes',
    width: LIST_WIDTH.xxl,
  },
];
